import React from "react";

const SettingsApi = () => {
  return <div>Not implemented yet.</div>;
};

export default SettingsApi;
